import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutos - dados considerados frescos
      gcTime: 10 * 60 * 1000, // 10 minutos - garbage collection
      retry: 1,
      retryDelay: 500, // Delay entre retries reduzido
      refetchOnWindowFocus: false,
      refetchOnReconnect: true, // Atualizar ao reconectar
      refetchOnMount: false, // Não refetch se dados em cache
      structuralSharing: true, // Otimiza re-renders
      refetchInterval: false, // Desabilita polling automático
    },
    mutations: {
      retry: 0,
    },
  },
});
